<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
        <el-form-item>
            <el-button-group style="margin: 5px 0">
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
                <!--<el-button type="primary" @click="pullTag">同步标签</el-button>-->
            </el-button-group>
        </el-form-item>
        </el-form>

        <div class="content-wrap">
            <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="ruleName" label="规则名称"  width="120"></el-table-column>
                <el-table-column prop="ruleGroupName" label="规则组名称" width="120"></el-table-column>
                <el-table-column prop="ruleTypeName" label="规则类型名称" width="120"></el-table-column>
                <el-table-column prop="ruleValueTypeName"  label="规则值类型名称" ></el-table-column>
                <el-table-column prop="operateTypeName"  label="操作类型名称" ></el-table-column>
                <el-table-column prop="ruleValue" label="规则值" width="150" ></el-table-column>
                <el-table-column prop="createTime"  label="创建时间" ></el-table-column>
                <el-table-column label="操作" fixed="right" width="250">
                    <template slot-scope="scope">
                        <el-button-group style="margin: 5px 0">
                            <el-button type="danger"  size="mini" @click="handDelete(scope.row)">删除</el-button>
                            <el-button type="primary"  size="mini" @click="handleEdit(scope.row)">修改规则组关系</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>
                <el-form-item label="规则名称" required="true" >
                    <el-input type="text" v-model=form.ruleName clearable  placeholder="规则名称" maxlength="100"
                              show-word-limit></el-input>
                </el-form-item>
                <!--<el-form-item label="规则组" required="true" >-->
                    <!--<el-select v-model="form.ruleGroupId" clearable filterable placeholder="所属组" >-->
                        <!--<el-option v-for="item in groupData"-->
                                   <!--:key="item.ruleGroupId"-->
                                   <!--:label="item.groupName"-->
                                   <!--:value="item.ruleGroupId">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->

                <el-form-item label="规则类型" required="true" >
                    <el-select v-model="form.ruleType" @change="onGroupChange" clearable filterable placeholder="规则类型" >
                        <el-option v-for="item in ruleTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作类型" required="true" >
                    <el-select v-model="form.operateType" @change="onGroupChange" clearable filterable placeholder="操作类型" >
                        <el-option v-for="item in operateTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item  label="规则值类型" >
                    <el-select v-model="form.ruleValueType"  clearable filterable placeholder="规则值类型" >
                        <el-option v-for="itemD in ruleValueTypeData"
                                   :key="itemD.id"
                                   :label="itemD.name"
                                   :value="itemD.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="规则值" required="true" >
                    <el-input type="text" v-model=form.ruleValue clearable  placeholder="规则名称" maxlength="100"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button-group style="margin: 5px 0">
                        <el-button @click="dialogFormVisible = false"  size="mini">取 消</el-button>
                        <el-button type="primary" size="mini" @click="save(form)">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getTagList,getTagRuleGroupList,getTagRuleList,saveRule,deletRule} from '../../api/api';
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                groupData:[],
                showAddGroup:false,
                statusData:[{"id":0,"name":"否"},{"id":1,"name":"是"}],
                conditionTypeData:[{"id":1,"name":"且"},{"id":2,"name":"或"}],
                operateTypeData:[{"id":1,"name":"等于"},{"id":2,"name":"不等于"},{"id":3,"name":"大于"},{"id":4,"name":"大于等于"},{"id":5,"name":"小于"},{"id":6,"name":"小于等于"},{"id":7,"name":"包含"},{"id":8,"name":"不包含"}],
                ruleTypeData:[{"id":0,"name":"最后一次购买距今天数"},{"id":1,"name":"购买次数"},{"id":2,"name":"购买总金额"},{"id":3,"name":"一段时间内购买次数"},{"id":4,"name":"包年订购次数"},
                    {"id":5,"name":"购买渠道名称"},{"id":6,"name":"奶卡购买次数"},{"id":7,"name":"次卡剩余次数"},{"id":12,"name":"聊天频率(多少天内多少次)"},{"id":13,"name":"购买最多省份"}],
                ruleValueTypeData:[{"id":0,"name":"数字"},{"id":1,"name":"字符串"},{"id":2,"name":"布尔值"}],
                loading:true,
                dialogFormVisible:false,
                dialogFormRuleGrouVisible:false,
                tagData:{},
                groupName:''||this.$route.query.groupName,
                form:{"id": null,
                    "ruleGroupId": "",
                    "ruleName": "",
                    "ruleType":0,
                    "corpId":0,
                    "ruleValueType":1,
                    "operateType":1,
                    "ruleValue":""
                   },
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    ruleGroupId:null||this.$route.query.ruleGroupId,
                },
            }
        },
        //挂载时候执行
        mounted(){
            //this.getGroupList();
            this.getList();
        },
        components:{

        },
        methods:{
            //定义查询方法
            getList(){
                this.loading=true
                getTagRuleList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;
                })
            },
            editTagRuleGroup(row){

            },
            getGroupList(){
                this.loading = true;
                getTagRuleGroupList({currentPage:1,pageSize:3000}).then((res) => {
                    this.loading = false;
                    //this.formInline.recordsTotal = res.data.value.total;
                    this.groupData = res.data.value.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(){
                this.dialogFormVisible=true;
                this.form={"id": null,
                    "ruleGroupId":this.formInline.ruleGroupId,
                    "ruleName": ""||this.$route.query.groupName,
                    "ruleType":3,
                    "corpId":0,
                    "ruleValueType":0,
                    "operateType":1,
                    "ruleValue":""
                }
            },
            addOne(){
                this.form.tag.push({
                    name:'',
                    sort:this.form.tag.length+1,
                    conditionType:1
                });
            },
            handleEdit(data){
                this.form=data
                this.dialogFormRuleGrouVisible=true
            },
            save(data){
                console.log(data);
                //保存标签
                saveRule(data).then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            saveTagItemCondition(){
                saveTag(this.tagData).then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormRuleGrouVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            handDelete(row){
                this.$confirm('删除'+row.name+', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deletRule({id:row.id}).then((res) => {
                        this.loading = false;
                        if(res.data.success){
                            this.$message({
                                message:res.data.message,
                                type:'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        }else{
                            this.$message({
                                message:res.data.message,
                                type:'error'
                            });
                        }
                    })
                });
            },
            returnHistory(){
                window.history.back()
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/distribution/tagRule.vue